export function getErrorCode(error: unknown): string | undefined {
  const code =
    error && typeof error === 'object' && 'code' in error
      ? (error as { code?: unknown }).code
      : undefined
  return typeof code === 'string' ? code : undefined
}
